<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="cancelDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>
      <v-card-text>
        <FacilityContractForm
          ref="facilityContractForm"
          @dialogClosed="() => {dialog = false; $emit('dialogClosed')}"
          @cancelDialog="cancelDialog"
          @updateContractData="(tableOptions, tableSearch) => $emit('updateContractData', tableOptions, tableSearch)"
          :isGlobal="isGlobal" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import FacilityContractForm from '@/modules/book/views/facility/facility/formDialogs/form/FacilityContractForm.vue';

export default {
  name: 'FacilityContractDialogForm',
  components: {
    FacilityContractForm
  },
  data() {
    return {
      dialog: false
    }
  },
  props: {
    isGlobal: Boolean
  },
  methods: {
    cancelDialog() {
      document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
      this.$refs.facilityContractForm.cleanupDialogForm();
      this.dialog = false
    },
    editGlobalContract(facilityBuildList, item, option, search) {
      this.$refs.facilityContractForm.editGlobalContract(facilityBuildList, item, option, search);
      this.dialog = true;
    },
    editContract(item, options, search) {
      this.$refs.facilityContractForm.editContract(item, options, search);
      this.dialog = true;
    },
    openNewContractDialog(options, search) {
      this.$refs.facilityContractForm.openNewContractDialog(options, search);
      this.dialog = true;
    },
    setParsedType(parsedType) {
      this.$refs.facilityContractForm.setParsedType(parsedType);
    }
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.$refs.facilityContractForm.loadEnums();
      }
    }
  }
}
</script>
